module.exports = __webpack_public_path__ + "static/media/centauro.62eb11ae.jpg";